
import { Webarticle } from '../../../react4xp/parts/webarticle/webarticle'

export default (props) => <Webarticle {...props} />